<div class="form-select-container" (click)="onOutsideClick()">
    <div class="select-button"
       [class.disabled]="disabled"
       [class.focused]="isOpen"
       (click)="onButtonClick($event)">
    <div class="button-text" [class.placeholder]="!selectedValue">
      {{ displayValue }}
    </div>
    <div class="button-icon">
      <img src="assets/icons/keyboard_arrow_down_new.svg" alt="dropdown">
    </div>
  </div>

  <div class="dropdown-menu" *ngIf="isOpen" (click)="$event.stopPropagation()">
    <!-- Search Bar -->
    <div class="search-container" *ngIf="showSearch">
      <input
        type="text"
        class="search-input"
        placeholder="Search"
        [value]="searchQuery()"
        (input)="onSearchInput($event)"
        (click)="onSearchClick($event)">
    </div>

    <!-- Options List -->
    <div class="options-list">
      <div
        class="option-item"
        *ngFor="let item of filteredContentList"
        [class.selected]="selectedValue?.value === item.value"
        [class.unavailable]="item.status === 'unavailable'"
        (click)="onItemClick(item, $event)">
        {{ item.label }}
      </div>

      <!-- No results message -->
      <div class="no-results" *ngIf="filteredContentList.length === 0 && searchQuery()">
        No results found
      </div>
    </div>
  </div>
</div>
